var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useState } from 'react';
import { Colors, FlexBox } from '@brg/ui';
import { IPhoneSwitcher } from './IPhoneSwitcher';
import useLocalization from '../../../../../../hooks/useLocalization';
import styled from 'styled-components';
var Label = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n"], ["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n"])), Colors.galBlack61);
export var CopyLinkSwitcher = function () {
    var _a = useState(localStorage.getItem('copyLinkMode') === 'true'), active = _a[0], setActive = _a[1];
    var t = useLocalization().t;
    var onSetActive = useCallback(function (value) {
        localStorage.setItem('copyLinkMode', value ? 'true' : 'false');
        setActive(value);
    }, []);
    useEffect(function () {
        var onSetStorage = function (e) {
            if (e.key === 'copyLinkMode') {
                setActive(e.newValue === 'true');
            }
        };
        window.addEventListener('storage', onSetStorage);
        return function () {
            localStorage.setItem('copyLinkMode', 'false');
            window.removeEventListener('storage', onSetStorage);
        };
    }, []);
    return (React.createElement(FlexBox, { gx: 8, align: 'center' },
        React.createElement(IPhoneSwitcher, { active: active, setActive: onSetActive }),
        React.createElement(Label, null, t('lms.podcast.copy_link_mode'))));
};
var templateObject_1;
//# sourceMappingURL=CopyLinkSwitcher.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useCallback, useEffect, useState } from 'react';
import { Colors, FlexBox } from '@brg/ui';
import { IPhoneSwitcher } from './IPhoneSwitcher';
import useLocalization from '../../../../../../hooks/useLocalization';
import styled from 'styled-components';
var Label = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n"], ["\n  color: ", ";\n  font-size: 13px;\n  font-weight: 400;\n  line-height: 16px;\n"])), Colors.galBlack61);
export var CopyLinkSwitcher = function () {
    var _a = useState(localStorage.getItem('copyLinkMode') === 'true'), active = _a[0], setActive = _a[1];
    var t = useLocalization().t;
    var onSetActive = useCallback(function (value) {
        localStorage.setItem('copyLinkMode', value ? 'true' : 'false');
        setActive(value);
    }, []);
    useEffect(function () {
        var onSetStorage = function (e) {
            if (e.key === 'copyLinkMode') {
                setActive(e.newValue === 'true');
            }
        };
        window.addEventListener('storage', onSetStorage);
        return function () {
            localStorage.setItem('copyLinkMode', 'false');
            window.removeEventListener('storage', onSetStorage);
        };
    }, []);
    return (React.createElement(FlexBox, { gx: 8, align: 'center' },
        React.createElement(IPhoneSwitcher, { active: active, setActive: onSetActive }),
        React.createElement(Label, null, t('lms.podcast.copy_link_mode'))));
};
var templateObject_1;
//# sourceMappingURL=CopyLinkSwitcher.js.map